import React, { Component } from 'react';
import { Tabs, Tab, ButtonToolbar, Button, Col, Modal, Form, ControlLabel, FormGroup, FormControl } from 'react-bootstrap';
import { PropTypes } from 'prop-types';

import { EditionsList } from '../EditionsList';
import { EditionNameForm } from '../forms/EditionNameForm';
import { EditionsCommand } from '../../commands/EditionsCommand';
import { AddOnsDataManagerCommand } from '../../../addOns/commands/AddOnsCommand';
import { SearchBar } from '../../../SearchBar';
import { TitleRow } from '../../../TitleRow';
import { HandleMessage } from '../../../HandleMessage';
import { LoadingSpinner } from '../../../LoadingSpinner';

export class ProviderEditions extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string,
        edition: PropTypes.object
    }

    constructor(props) {
        super(props);

        this.state = {
            showEditionUpdateModal: false,
            selectedDate: new Date().toISOString().slice(0, 10),
            addOns: [],
            selectedTab: "network",
            filter: "",
            form: {
                operation: "create",
                showNameForm: false,
                inputError: null,
                id: 0,
                name: "",
                successMessage: ""
            },
            callbacks: {
                list: {
                    network: undefined,
                    planning: undefined
                },
                refresh: {
                    network: undefined,
                    planning: undefined
                }
            },
            actions: {
                isLoadingAddOns: true,
                isUpdatingEditions: false,
                isExecutingAddOn: false
            },
            commands: {
                editions: new EditionsCommand(),
                addOns: new AddOnsDataManagerCommand()
            },
            render: {
                addOn: ""
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            }
        };
    }

    componentDidMount() {
        this.context.selectApp('datamanager', false);
        this.getAddOns();
    }

    // ---------------------------

    getAddOns() {
        const { commands, actions } = this.state;

        actions.isLoadingAddOns = true;

        commands.addOns.get(
            (a) => this.addOnsSuccessCallback(a),
            () => this.addOnsErrorCallback()
        );
    }

    // ---------------------------

    addOnsSuccessCallback(result) {
        const { actions } = this.state;

        actions.isLoadingAddOns = false;

        this.setState({
            addOns: result,
            actions: actions
        });
    }

    listCallback(type, func) {
        const { callbacks } = this.state;

        callbacks.list[type] = func;

        this.setState({
            callbacks: callbacks
        });
    }

    refreshCallback(type, func) {
        const { callbacks } = this.state;

        callbacks.refresh[type] = func;

        this.setState({
            callbacks: callbacks
        });
    }

    addOnsErrorCallback() {
        const { actions } = this.state;

        actions.isLoadingAddOns = false;

        this.setState({
            actions: actions
        });
    }

    operationSuccessCallback(type, message) {
        const { edition } = this.context;
        const { callbacks } = this.state;

        if ("function" === typeof callbacks.refresh[type]) {
            callbacks.refresh[type]();
        }

        // Update Provider selected Editions
        if (null !== edition && undefined !== edition) {
            edition.update(edition.date, undefined, true);
        }
        this.onHideForm();

        this.setState({
            message: {
                show: true,
                message: message,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });
    }

    addOnOperationSuccessCallback(message, action) {
        const { actions } = this.state;
        
        actions[action] = false;

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });
    }

    operationErrorCallback(message) {
        this.onHideForm();
        
        this.setState({
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    addOnOperationErrorCallback(message, action) {
        const { actions } = this.state;

        actions[action] = false;

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // ---------------------------

    getAddOnsCallback(type) {
        const { addOns } = this.state;

        return addOns.filter(addOn => addOn.enabled && addOn.name.toLowerCase().startsWith(type));
    }

    planningEditionDependenciesCallback() {
        const { callbacks } = this.state;

        return {
            networkEditions: "function" === typeof callbacks.list.network ? [{ id: 0, name: "Manter Edição de Rede" }].concat(callbacks.list.network().filter(edition => 3 !== edition.state)) : undefined
        };
    }

    // ---------------------------

    onExecuteAddOn(addOn, label, edition) {
        const { commands, actions, render } = this.state;

        render.addOn = label;
        actions.isExecutingAddOn = true;
        commands.addOns.execute(
            addOn,
            label,
            { networkEdition: edition },
            (a) => this.addOnOperationSuccessCallback(a, "isExecutingAddOn"),
            (a) => this.addOnOperationErrorCallback(a, "isExecutingAddOn")
        );
        
        this.setState({
            actions: actions
        });
    }

    onSearch(filter) {
        this.setState({
            filter: filter
        });
    }

    onSelectTab(key) {
        this.setState({
            selectedTab: key
        });
    }

    onCreateClick() {
        const { form } = this.state;

        form.id = 0;
        form.name = "";
        form.inputError = null;
        form.showNameForm = true;
        form.successMessage = "Edição criada com sucesso.";

        this.setState({
            form: form
        });
    }

    onEditionUpdateClick() {
        this.setState({ showEditionUpdateModal: true });
    }

    onChangeNameForm(input) {
        const { form } = this.state;

        form.name = input.target.value;
        if (null === form.name || undefined === form.name || "" === form.name) {
            form.inputError = "error";
        }
        else {
            form.inputError = null;
        }

        this.setState({
            form: form
        });
    }

    onHideEditionUpdateModal = () => {
        this.setState({
            showEditionUpdateModal: false
        });
    };

    onConfirmEditionUpdate = () => {
        const { selectedDate, commands, actions } = this.state;

        actions.isUpdatingEditions = true;

        this.setState({
            showEditionUpdateModal: false,
            actions: actions
        });

        commands.editions.updateEditions(
            selectedDate,
            () => this.editionsUpdateSuccessCallback("isUpdatingEditions"),
            (a) => this.editionsUpdateErrorCallback(a, "isUpdatingEditions")
        );
    };

    editionsUpdateSuccessCallback(action) {
        const { actions } = this.state;
        
        const { edition } = this.context;
        const { callbacks } = this.state;

        if ("function" === typeof callbacks.refresh.network) {
            callbacks.refresh.network();
        }

        if ("function" === typeof callbacks.refresh.planning) {
            callbacks.refresh.planning();
        }

        // Update Provider selected Editions
        if (null !== edition && undefined !== edition) {
            edition.update(edition.date, undefined, true);
        }

        actions[action] = false;
        
        this.setState({
            message: {
                show: true,
                message: "Sucesso a atualizar as edições!",
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });
    }

    editionsUpdateErrorCallback(message, action) {
        const { actions } = this.state;

        const { edition } = this.context;
        const { callbacks } = this.state;

        if ("function" === typeof callbacks.refresh.network) {
            callbacks.refresh.network();
        }

        if ("function" === typeof callbacks.refresh.planning) {
            callbacks.refresh.planning();
        }

        // Update Provider selected Editions
        if (null !== edition && undefined !== edition) {
            edition.update(edition.date, undefined, true);
        }

        actions[action] = false;

        this.setState({
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    onDateChange = (e) => {
        this.setState({
            selectedDate: e.target.value
        });
    };

    onSaveNameForm() {
        const { selectedTab, form, commands } = this.state;

        commands.editions.save(
            selectedTab,
            form,
            () => this.operationSuccessCallback(selectedTab, form.successMessage),
            (a) => this.operationErrorCallback(a)
        );
    }

    onHideForm() {
        const { form } = this.state;

        form.showNameForm = false;

        this.setState({
            form: form
        });
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    // ---------------------------

    renderNameForm() {
        const { form } = this.state;

        if (form.showNameForm) {
            return (
                <EditionNameForm title="Introduza o nome da Edição"
                    value={form.name}
                    inputError={form.inputError}
                    onChangeValue={(a) => this.onChangeNameForm(a)}
                    onSave={() => this.onSaveNameForm()}
                    onHide={() => this.onHideForm()} />
            );
        }

        return null;
    }

    render() {
        const { selectedTab, filter, actions, render, message } = this.state;

        return (
            <div>
                <TitleRow title="Edições" showSeparator={true}>
                    <Col className="padding-0" xs={2} sm={1} md={4}>
                        <ButtonToolbar className="pull-right title-row-col-btns">
                            <Button onClick={() => this.onEditionUpdateClick()}>ATUALIZAR EDIÇÕES</Button>
                            <Button onClick={() => this.onCreateClick()}>CRIAR</Button>
                        </ButtonToolbar>
                    </Col>
                    <Col className="padding-0" xs={10} sm={11} md={8}>
                        <div className="search-bar">
                            <SearchBar onSearch={(a) => this.onSearch(a)} />
                        </div>
                    </Col>
                </TitleRow>

                <div className="margin-top-15">
                    <Tabs id="datamanager_tabs" activeKey={selectedTab} onSelect={(a) => this.onSelectTab(a)}>
                        <Tab eventKey="network" title="Rede">
                            <EditionsList type="network"
                                filter={filter}
                                isLoading={actions.isLoadingAddOns}
                                getAddOnsCallback={() => this.getAddOnsCallback("network")}
                                refreshCallback={(a) => this.refreshCallback("network", a)}
                                listCallback={(a) => this.listCallback("network", a)}
                                onExecuteAddOn={((a, b, c) => this.onExecuteAddOn(a, b, c))} />
                        </Tab>
                        <Tab eventKey="planning" title="Planeamento">
                            <EditionsList type="planning"
                                filter={filter}
                                isLoading={actions.isLoadingAddOns}
                                getAddOnsCallback={() => this.getAddOnsCallback("planning")}
                                refreshCallback={(a) => this.refreshCallback("planning", a)}
                                listCallback={(a) => this.listCallback("planning", a)}
                                dependenciesCallback={() => this.planningEditionDependenciesCallback()}
                                onExecuteAddOn={((a, b, c) => this.onExecuteAddOn(a, b, c))}  />
                        </Tab>
                    </Tabs>
                </div>

                {this.renderNameForm()}
                {this.state.showEditionUpdateModal &&
                    <Modal show={true}>
                        <Modal.Header>
                            <Modal.Title>Selecionar Data</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                            <Form>
                                <FormGroup controlId="formEditionDate">
                                    <ControlLabel>Data</ControlLabel>

                                    <FormControl
                                        type="date"
                                        value={this.state.selectedDate}
                                        onChange={this.onDateChange}
                                    />
                                </FormGroup>
                            </Form>

                            <ButtonToolbar>
                                <Button onClick={this.onConfirmEditionUpdate}>
                                    OK
                                </Button>

                                <Button onClick={this.onHideEditionUpdateModal}>
                                    CANCELAR
                                </Button>
                            </ButtonToolbar>
                        </Modal.Body>
                    </Modal>
                }

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />

                <HandleMessage
                    title={`A ${render.addOn}`}
                    message={<LoadingSpinner />}
                    style={`primary`}
                    icon="transfer"
                    show={actions.isExecutingAddOn}
                    small
                    noButtons />

                <HandleMessage
                    title={`A Executar`}
                    message={<LoadingSpinner />}
                    style={`primary`}
                    icon="transfer"
                    show={actions.isUpdatingEditions}
                    small
                    noButtons />
            </div>
        );
    }
}
